import styled from 'styled-components';

export default styled.section`
	width: ${(props) => props.width || 'calc(100% - var(--px-50))'};
	color: var(--blue-600);
	font-weight: bold;
`;
